import PropTypes from 'prop-types'
import React from 'react'

import { getPaymentsFromOrder } from '@/checkout-instore-legacy/order/utils'

import OrderPlacedPayment from './OrderPlacedPayment'

export default function OrderPlacedPaymentDetail({ order }) {
  const payments = getPaymentsFromOrder(order)
  return (
    <div className="OrderPlacedPaymentDetail component">
      {payments.map((payment) => (
        <OrderPlacedPayment key={payment.id} payment={payment} />
      ))}
    </div>
  )
}

OrderPlacedPaymentDetail.propTypes = {
  order: PropTypes.object.isRequired,
}
